import type { OfferRequestAttachment } from '@houzy/schemas/offer-request-management';

export function isImageAttachment(attachment: Pick<OfferRequestAttachment, 'mimeType'>): boolean {
    return attachment.mimeType.startsWith('image/');
}
